import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HudPage from "@/pages/HudPage";
import RulebookPage from "@/pages/RulebookPage";
import CasinoPage from "@/pages/CasinoPage";
import AdminPage from "@/pages/AdminPage";
import { initGA } from "@/lib/analytics";

function SprintRedirect() {
  useEffect(() => { window.location.replace("/sprint.html"); }, []);
  return null;
}

function PodiumRedirect() {
  useEffect(() => { window.location.replace("/podium.html"); }, []);
  return null;
}

function PodiumAscendRedirect() {
  useEffect(() => { window.location.replace("/podium.ascend.html"); }, []);
  return null;
}

function SprintGrindRedirect() {
  useEffect(() => { window.location.replace("/sprint.grind.html"); }, []);
  return null;
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CasinoPage variant="v1" />} />
          <Route path="/v1" element={<CasinoPage variant="v1" />} />
          <Route path="/v2" element={<HudPage variant="v2" />} />
          <Route path="/v3" element={<HudPage variant="v3" />} />
          <Route path="/v4" element={<HudPage variant="v4" />} />
          <Route path="/v5" element={<HudPage variant="v5" />} />
          <Route path="/v6" element={<HudPage variant="v6" />} />
          <Route path="/v7" element={<HudPage variant="v7" />} />
          <Route path="/podium" element={<PodiumRedirect />} />
          <Route path="/sprint" element={<SprintRedirect />} />
          <Route path="/sprint.grind" element={<SprintGrindRedirect />} />
          <Route path="/podium.ascend" element={<PodiumAscendRedirect />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
